<template>
    <section class="general-modal">
        <h1 class="modal-title">Privacyverklaring</h1>
        <p>Testaankoop strijdt al vele jaren voor consumentenrechten, en heeft het belang van de bescherming van privacy en persoonsgegevens altijd verdedigd.
            Daarom vindt u in deze privacyverklaring alle informatie terug die nodig zijn om beter te begrijpen hoe wij uw persoonsgegevens verwerken.
        </p>
        <p>Wij raden u aan dit document regelmatig te lezen, aangezien het mogelijk is dat we het in de toekomst actualiseren en/of wijzigen.</p>

        <h2>1. Gezamenlijke Verwerkingsverantwoordelijken</h2>

        <p><strong>De Belgische Verbruikersunie Test-Aankoop VZW</strong> vereniging zonder winstoogmerk, met ondernemingsnummer BE 0407.703.668, en  <strong>de Verbruikersunie Testaankoop CV</strong> , coöperatieve vennootschap met ondernemingsnummer BE 0425.989.356, zijn de gezamenlijke verwerkingsverantwoordelijken van uw persoonsgegevens.
            Zij zijn beide gevestigd in 1060 Brussel, Hollandstraat 13 en u kunt contact opnemen door een e-mail te versturen naar <a href="mailto:privacy@test-aankoop.be">privacy@test-aankoop.be</a>
            (hierna
            «<strong>Gezamenlijke Verwerkingsverantwoordelijken</strong>» of « <strong>Testaankoop</strong>».</p>

        <p>De Gezamenlijke Verwerkingsverantwoordelijken hebben een overeenkomst gesloten op grond van art. 26 van de AVG waarin ze zich er onder meer toe verbinden:</a>.</p>
        <ul>
            <li>gezamenlijk een aantal doeleinden en middelen van de verwerking van uw persoonsgegevens te bepalen;</li>
            <li>gezamenlijk een procedure vast te stellen om u tijdig een antwoord te bezorgen indien u uw rechten op grond van artikel 15 en volgende van de AVG zou willen uitoefenen;</li>
            <li>gezamenlijk deze privacyverklaring vast te stellen.</li>
        </ul>

        <h2>2. Functionaris voor Gegevensbescherming</h2>
        <p>De Gezamenlijke Verwerkingsverantwoordelijken hebben elk op grond van art. 37 van de AVG een Functionaris voor Gegevensbescherming (hierna ‘DPO’) aangesteld die u op het volgend e-mailadres kunt contacteren:
            <a href="mailto:privacyteam@test-aankoop.be">privacyteam@test-aankoop.be</a>.</p>

        <h2>3. Doeleinde en rechtsgrond van de verwerking van persoonsgegevens</h2>
        <p>Indien u nog geen lid, abonnee of supporter bent van Testaankoop kunnen uw contactgegevens gebruikt worden voor direct marketingdoeleinden. Telemarketing wordt overeenkomstig artikel VI.112 van het Wetboek van economisch recht uitgevoerd nadat is nagegaan of er geen verzet is aangetekend op de "bel-me-niet-meer" lijst (<a href="https://www.dncm.be" target="_blank">www.dncm.be</a>). ). Informatie omtrent hoe Testaankoop uw gegevens heeft bekomen kan steeds opgevraagd worden via email naar
            <a href="mailto:privacy@test-aankoop.be">privacy@test-aankoop.be</a> of per telefoon op 02 542 32 00.</p>
        <p>In onderstaande tabel vindt u een overzicht van de categorieën van persoonsgegevens die wij verwerken, de ermee samenhangende doeleinden en de rechtsgrond voor de verwerking.</p>
        <p>Wij wijzen u erop dat wij, samen met de hieronder genoemde doeleinden, uw gegevens bovenal verwerken om te voldoen aan onze verplichtingen in het kader van onze contractuele relatie met u en om u marketingcommunicatie over onze diensten te sturen, tenzij u ons geen toestemming geeft door het specifieke vakje onderaan het webformulier aan te kruisen of door uw toestemming aan te passen in uw persoonlijke ruimte op onze website.</p>
        <p>Collectieve Aankopen, Publieke Petities, Groepsvorderingen, gebruik van het klachtenformulier en andere acties die mogelijk tot de missie van Testaankoop behoren, kunnen indien nodig meer informatie over de verwerking van uw gegevens voor die specifieke doeleinden impliceren. In dat geval zal aanvullende informatie aan u worden verstrekt op de daartoe bestemde webpagina en zal die voor u bindend zijn zodra u inschrijft voor de actie. Deze specifieke voorwaarden zullen worden beschouwd als een aanvullend onderdeel van dit Privacybeleid. In geval van tegenstrijdigheid hebben de speciale regels voorrang op de algemene regels die in dit Privacybeleid zijn opgenomen.</p>
        <p>Het is mogelijk dat niet alle hier genoemde doeleinden van toepassing zijn op u, en dat niet alle verwerkingen beschreven staan. Indien u dit wenst gebruik te maken van alle aangeboden diensten, kunnen wij u alle scenario’s bezorgen die op u van toepassing zijn.</p>
        <p>De opgegeven voorbeelden zijn illustratief  en geven niet alle mogelijke situaties weer.</p>
        <p>Het verstrekken van persoonsgegevens waarbij een (*) is vermeld op het internet is verplicht. gegevens, zullen wij niet in staat zijn om de door u gevraagde dienst te leveren.</p>


        <table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
               style='border-collapse:collapse;mso-yfti-tbllook:1184'>
            <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Identificatiegegevens&nbsp;(naam,
  familienaam, geboortedatum) en contactgegevens (e-mail, telefoonnummer,
  adres), lidnummer, gebruikersnaam en wachtwoord op de website<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:1'>
                <td style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Doeleinde<o:p></o:p></span></p>
                </td>
                <td style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Rechtsgrond<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:2'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Registratie als
  Supporter of als Lid/abonnee op de website van&nbsp;</span><a
                        href="http://www.testaankoop.be/"><span style='font-family:"Lato",sans-serif;
  mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
  color:#0086CE;mso-fareast-language:EN-GB'>www.testaankoop.be</span></a><span
                        style='font-family:"Lato",sans-serif;mso-fareast-font-family:"Times New Roman";
  mso-bidi-font-family:"Times New Roman";color:#4A4A4A;mso-fareast-language:
  EN-GB'>&nbsp;en/of gerelateerde websites/pagina’s<o:p></o:p></span></p>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>&nbsp;<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele of precontractuele overeenkomst: door in te
  schrijven op onze website, stemt u in met het gebruik van onze diensten onder
  de volgende voorwaarden:&nbsp;</span><a
                        href="https://www.test-aankoop.be/info/algemene-voorwaarden" target="_blank"><span
                        style='font-family:"Lato",sans-serif;mso-fareast-font-family:"Times New Roman";
  mso-bidi-font-family:"Times New Roman";color:#0086CE;mso-fareast-language:
  EN-GB'>algemene voorwaarden</span></a><span style='font-family:"Lato",sans-serif;
  mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
  color:#4A4A4A;mso-fareast-language:EN-GB'>.<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:3'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Lidmaatschap van
  de vereniging Testaankoop en abonnement op een of meer van haar
  tijdschriften of diensten<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele of precontractuele overeenkomst<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:4'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Beheer van uw
  abonnementen (bv. levering, terugbetaling), verwerken van gerelateerde vragen<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele of precontractuele overeenkomst; naleving
  van een wettelijke verplichting<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:5'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>De behandeling
  van klachten en de preventie van fraude ten aanzien van Testaankoop<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gerechtvaardigd
  Belang bij de bescherming van de belangen van de Gezamenlijke
  Verwerkingsverantwoordelijken; naleving van een wettelijke verplichting
  (bijvoorbeeld: strafrecht)<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:6'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Deelname aan
  Petities, Aankoopgroepen en andere acties van Testaankoop.<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele of precontractuele overeenkomst; vervullen
  van een wettelijke verplichting<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:7'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Deelname aan een
  evenement (bijvoorbeeld seminaries, opleidingen enz.)<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Toestemming of
  Gerechtvaardigd Belang bij interactie met de deelnemers, uitvoering van
  contractuele verplichtingen; naleving van een wettelijke verplichting<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:8'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Verstrekking van
  advies op juridisch, fiscaal of ander gebied per telefoon of e-mail of via
  papieren post<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele of precontractuele overeenkomst<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:9'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Vrijwillige
  deelname door geselecteerde personen aan producten- en of dienstentests<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele of precontractuele overeenkomst<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:10'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Verzending van
  geschenken, reclamegidsen of ander gratis materiaal<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele overeenkomst of Gerechtvaardigd Belang bij
  het verbeteren van de consumententrouw<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:11'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gebruik van onze
  vergelijkers en calculatoren<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele overeenkomst<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:12'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Informatie over
  de strijdacties, de behaalde resultaten en de volgende doelstellingen van
  Testaankoop<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gerechtvaardigd
  Belang om onze waarden zoveel mogelijk te promoten<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:13'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal><span style='font-family:"Times New Roman",serif;
  mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-GB'>Deelname
  aan een project of actie gefinancierd met Belgische of Europese
  overheidsfondsen<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal><span style='font-family:"Times New Roman",serif;
  mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-GB'>Toestemming
  of wettelijke verplichting vervat in het toekenningsbesluit voor het gesubsidieerde
  project<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:14'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consumententevredenheidsonderzoeken
  over producten en/of diensten met gelijktijdige publicatie van artikelen in
  onze tijdschriften<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gerechtvaardigd
  Belang bij het nastreven van onze waarden voor de bescherming van de
  consument<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:15'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Statistieken gebaseerd
  op uw gebruik van onze producten of diensten<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Toestemming of
  Gerechtvaardigd Belang om ons aanbod te verbeteren<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:16'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Informatie over
  de beste prijzen, kortingen en kansen waarover Testaankoop heeft
  onderhandeld om de aankoop voor u te vergemakkelijken (direct marketing)<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gerechtvaardigd
  belang (zie art. 3.2); toestemming, indien wettelijk vereist<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:17'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Promotie van
  tijdschriften, gidsen en abonnementen op Testaankoop (direct marketing)<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gerechtvaardigd
  belang (zie art. 3.2); toestemming, indien wettelijk vereist<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:18'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gegevens die
  betrekking hebben op de diensten die u gebruikt en uw interesses&nbsp;die
  worden getoond in het gebruik van onze sites of in uw communicatie met Test
  Aankoop<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:19'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Dit laat ons toe
  om de informatie die u ziet en onze diensten aan te passen en de kiezen
  overeenkomstig uw interesses<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzaak voor de
  uitoefening van de overeenkomst, toestemming via de cookies, gerechtvaardigd
  belang<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:20'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>E-mails, brieven,
  contracten, bestelbonnen<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:21'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>De gegevens die
  nodig zijn om u een antwoord te geven op uw vraag, indien u gebruik maakt van
  onze dienst van persoonlijke hulp. Deze gegevens worden niet gebruikt voor
  andere doeleinden dan het beantwoorden van uw vraag<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzaak voor de
  uitoefening van de overeenkomst, toestemming via de cookies, gerechtvaardigd
  belang<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:22'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Foto's, video's,
  audio<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:23'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Vrijwillige
  deelname aan interviews of studies in verband met onze artikelen die bestemd
  zijn voor publicatie in onze tijdschriften<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Toestemming<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:24'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Bankgegevens
  (voorbeeld: IBAN of kredietkaart)<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:25'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Betaling van
  aankopen, diensten en abonnementen<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Noodzakelijk voor
  de uitvoering van de contractuele of precontractuele overeenkomst<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:26'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Bijzondere
  gegevenscategorieën: gezondheidsgegevens<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:27;mso-yfti-lastrow:yes'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Verstrekking van
  consultaties via telefoon of e-mail over disfuncties in de gezondheids­administratie;
  Klachten die te maken hebben met gezondheidsproblemen;<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Toestemming<o:p></o:p></span></p>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>&nbsp;<o:p></o:p></span></p>
                </td>
            </tr>
        </table>


        <p>3.2 Overeenkomstig het Supporter contract dat u gesloten hebt met Testaankoop, ontvangt u informatie en aanbiedingen betreffende onze activiteiten. Indien u geen supporter bent van Testaankoop maar een abonnee bent geweest, kan Testaankoop u, op basis van het gerechtvaardigd belang en gedurende een redelijke periode, contacteren om haar diensten voor te stellen en aan te bieden. Deze gegevens worden niet aan derden doorgegeven voor marketingdoeleinden en hebt u het recht om u te verzetten tegen het ontvangen van commerciële berichten van Testaankoop op ieder moment van contactopname door op de “uitschrijf"-knop te drukken of op ieder moment door een e-mail te sturen naar
            <a href="mailto:privacy@test-aankoop.be">privacy@test-aankoop.be</a>, of via uw persoonlijke ruimte op de website: <a href="https://www.testaankoop.be/mijngegevens/persoonlijke-informatie" target="_blank">www.testaankoop.be/mijngegevens/persoonlijke-informatie</a>.</p>

        <h2>4. Delen van persoonsgegevens</h2>
        <p>4.1 Voor de correcte uitvoering van alle verwerkingsactiviteiten die nodig zijn voor de doeleinden zoals beschreven in art. 3 van deze privacyverklaring na te komen, kunnen uw persoonsgegevens ook worden verwerkt door de volgende partijen:</p>

        <ul>
            <li>•	derden die een deel van de verwerkingsactiviteiten uitvoeren op contractuele basis en/of in verband daarmee namens een van de Verwerkingsverantwoordelijken of beide Gezamenlijke Verwerkingsverantwoordelijken.
                In dat geval werden die personen aangewezen als verwerkers op grond van art. 28 van de AVG (hierna de ‘Verwerker’);
            </li>
            <li>•	personen, werknemers en/of medewerkers van een van de Verwerkingsverantwoordelijken of beide Gezamenlijke Verwerkingsverantwoordelijken aan wie specifieke en/of meer verwerkingsactiviteiten die betrekking hebben op uw persoonsgegevens werden toevertrouwd en die werden aangewezen als ‘Gemachtigde Personen’ op grond van art. 29 van de AVG.</li>
            <li>•	Uw persoonsgegevens kunnen worden meegedeeld aan overheidsorganen of aan de rechterlijke autoriteiten indien dat wettelijk verplicht is of om het plegen van een misdrijf te voorkomen of te bestraffen.</li>
        </ul>
        <p>Overeenkomstig art. 4, punt 9 van de AVG: ‘Overheidsinstanties die mogelijk persoonsgegevens ontvangen in het kader van een bijzonder onderzoek overeenkomstig het Unierecht of het lidstatelijke recht gelden echter niet als ontvangers’.</p>
        <p>Wanneer het doeleinde van de verwerking samenwerking met derden vereist, zoals groepsaankopen, kortingscampagnes, veilingen, publieke petities of groepsvorderingen, zullen alle gegevens die noodzakelijk zijn voor de derden om de dienst onder de overeengekomen voorwaarden (algemene voorwaarden plus speciale voorwaarden indien van toepassing) te leveren, aan hen worden verstrekt; Meer volledige informatie over deze mededelingen zal worden opgenomen in de betreffende bijzondere voorwaarden.</p>

        <p>4.2 Houd er rekening mee dat wij of onze verwerkers mogelijk gebruik maken van de diensten van bedrijven die mogelijk uw gegevens buiten de EER opslaan. In dat geval zorgen we er altijd voor dat die bedrijven gedekt zijn door een adequaatheidsbesluit van de Europese Commissie.</p>

        <p>4.3  In zeldzame gevallen kan het voorkomen dat Testaankoop uw Persoonsgegevens moet delen in het kader van de uitoefening van het openbaar gezag, ingevolge een gerechtelijk bevel of om te voldoen aan andere dwingende wet- of regelgeving. Testaankoop zal in redelijkheid pogen u van tevoren dienaangaande te informeren, tenzij dit niet toegelaten is.</p>

        <h2>5. Bewaring van persoonsgegevens</h2>
        <p>5.1 Tenzij u een verzoek tot annulering indient, bewaren de Gezamenlijke Verwerkings¬verantwoordelijken uw persoonsgegevens op de Testaankoop-website voor de duur van uw registratie.</p>

        <p>5.2 In het geval dat u ook lid en abonnee van Testaankoop magazines bent, bewaren wij uw persoonsgegevens voor een wettelijke termijn van maximaal 10 jaar vanaf de datum van beëindiging van uw abonnement.</p>

        <p>5.3 Vergeet niet dat u zowel lid bent (met het abonnement op onze magazines en andere diensten) als Supporter. Indien u beslist uw abonnement als lid te beëindigen, kunt u uw status als Supporter gratis behouden.</p>
        <p>Tenzij u expliciet verzoekt om alle contracten te beëindigen (zowel lidmaatschap als ‘Supporter’), kunt u dus gebruik blijven maken van de diensten die onze site rechtstreeks aanbiedt. Dus, als u alleen het lidmaatschapsabonnement opzegt, hou er dan rekening mee dat alle gegevens met betrekking tot de status van ‘Supporter’ worden bewaard en dat u onze communicatie zoals gedefinieerd in uw voorkeur zal blijven ontvangen, zelfs als u uw tijdschriftenabonnement opzegt.</p>

        <p>5.4 Na opzegging kunnen wij ook uw gegevens bewaren die absoluut noodzakelijk zijn om aan te tonen dat wij voldoen aan, daarbij inbegrepen maar niet beperkt tot, de toepasselijke wetten, zoals de AVG, de fiscale wetgeving of de wet op de verkoop op afstand.
            In dat geval bewaren wij alleen de gegevens die absoluut noodzakelijk zijn voor dat doeleinde en worden die bewaard mits bijkomende beveiliging, naar behoren gepseudonimiseerd, en alleen gedurende de beperkte termijn die kan verschillen naargelang de toepasselijke wetgeving.
        </p>
        <p>Indien de specifieke aard van een door Testaankoop georganiseerde actie andere bewaartermijnen vereist, wordt dat vermeld in het specifieke privacybeleid van de actie op de betreffende webpagina.</p>

        <h2>6. Rechten van de betrokkene</h2>
        <p>6.1 U kunt uw rechten volgens de AVG uitoefenen (inzage van persoonlijke informatie, rectificatie, recht op gegevenswissing, recht op beperking van de verwerking, recht op overdraagbaarheid, recht van bezwaar, recht op verzet tegen de verwerking voor marketingdoeleinden) door contact op te nemen met ons Privacy team op 6.1 U kunt uw rechten volgens de AVG uitoefenen (inzage van persoonlijke informatie, rectificatie, recht op gegevenswissing, recht op beperking van de verwerking, recht op overdraagbaarheid, recht van bezwaar, recht op verzet tegen de verwerking voor marketingdoeleinden) door contact op te nemen met ons Privacy team op
            <a href="mailto:privacy@test-aankoop.be">privacy@test-aankoop.be</a></p>
        <p>U kan hetzelfde e-mailadres eveneens gebruiken voor elke klacht of vraag tot informatie.</p>
        <p>Indien u van mening bent dat uw rechten overeenkomstig de AVG niet of onvoldoende worden nagekomen, hebt u het recht om een klacht in te dienen, per post bij de Gegevensbeschermingsautoriteit, Persstraat 35, te 1000 Brussel, per e-mail op contact@apd-gba.be of door volgende website te bezoeken van de Gegevensbeschermingsautoriteit:
            <a href="https://www.gegevensbeschermingsautoriteit.be/contact" target="_blank">www.gegevensbeschermingsautoriteit.be/contact</a>.</p>

        <p>6.2 U kunt ook een aantal van uw rechten uitoefenen in uw Persoonlijke ruimte op de website: <a href="https://www.testaankoop.be/mijngegevens/persoonlijke-informatie" target="_blank">www.testaankoop.be/mijngegevens/persoonlijke-informatie</a></p>

        <p>6.3 Aarzel niet om ons te bellen op 02 542 32 00 wanneer u twijfelt of problemen hebt met de uitoefening van uw rechten.</p>

        <p>6.4 Wanneer uw gegevens worden verwerkt op basis van uw toestemming (zie bovenstaande tabel), kunt u uw toestemming te allen tijde intrekken, zonder dat dat afbreuk doet aan de rechtmatigheid van de verwerking op basis van toestemming voordat die werd ingetrokken.</p>

        <p>6.5 Om aan uw verzoeken te voldoen, kunnen wij, indien de door u verstrekte informatie niet volstaat om u te identificeren, aanvullende gegevens vragen om uw identiteit te bewijzen op grond van artikel 11 van de AVG. Rekening houdend met de risico’s op datalekken, doen wij het mogelijke om uw identiteit te controleren, alvorens persoonsgegevens aan u door te sturen.
            Een kopie van de voorzijde van uw identiteitskaart kan u hiertoe gevraagd worden. U hebt het recht om uw identiteitskaartnummer en geboortedatum te schrappen.
        </p>

        <h2>7. Beveiliging</h2>
        <p>Testaankoop implementeert en handhaaft passende technische, organisatorische en veiligheidsmaatregelen om een veilige verwerking van persoonsgegevens te waarborgen.
            Die maatregelen omvatten bijvoorbeeld, maar zijn niet beperkt tot, het uitvoeren van vertrouwelijkheidsovereenkomsten met onze medewerkers en leveranciers, het beperken van de toegang tot persoonsgegevens, het vernietigen of anonimiseren van persoonsgegevens indien ze niet meer nodig zijn voor de doeleinden waarvoor ze zijn verzameld.

        </p>

        <p>Aangezien de beveiliging van informatie deels afhankelijk is van de beveiliging van de computer of het toestel dat u gebruikt om met ons te communiceren en de beveiliging die u gebruikt om (indien relevant) gebruikersnamen en wachtwoorden te beschermen, verzoeken wij u passende maatregelen te nemen om die gegevens te beschermen.</p>


    </section>
</template>

<script>
export default {
    name: "PrivacyModal"
}
</script>

<style scoped>

</style>
